import {
  AssigneeInputBlock,
  CardsInputBlock,
  DateInputBlock,
  FileInputBlock as FileInputBlockType,
  InputBlock,
  NumberInputBlock,
  RecurrenceInputBlock,
  ReminderInputBlock,
  SubformsInputBlock as SubformsInputBlockType,
  TagsInputBlock,
  TodoInputBlock,
} from '@coast/schemas';
import { MBCardInputBlockAddress } from './lib/inputAddress';
import { MBCardInputBlockAssignee } from './lib/inputAssignee';
import { MBCardInputBlockCards } from './lib/inputCards/MBCardInputBlockCards';
import { CardInputBlockDate } from './lib/inputDate';
import { FileInputBlock } from './lib/inputFile/FileInputBlock';
import { MBCardInputBlockGeolocation } from './lib/inputGeolocation';
import { MBCardInputBlockImage } from './lib/inputImage';
import { MBCardInputBlockNumber } from './lib/inputNumber';
import { MBCardInputBlockQuestion } from './lib/inputQuestion';
import { MBCardInputBlockRecurrence } from './lib/inputRecurrence';
import { MBCardInputBlockReminder } from './lib/inputReminder';
import { SignatureInputBlock } from './lib/inputSignature/SignatureInputBlock';
import { SubformsInputBlock } from './lib/inputSubforms/SubformsInputBlock';
import { MBCardInputBlockTags } from './lib/inputTags';
import { MBCardInputBlockText } from './lib/inputText';
import { MBCardInputBlockTextarea } from './lib/inputTextarea';
import { MBCardInputBlockTodo } from './lib/inputTodo';
import { MBCardInputBlockToggle } from './lib/inputToggle';

export function InputBlockComponent({
  block,
  onFieldPress,
  value,
  workflowTemplateId,
}: {
  block: InputBlock;
  onFieldPress: () => void;
  value: unknown;
  workflowTemplateId?: string;
}) {
  switch (block.fieldType) {
    case 'date':
    case 'time':
    case 'datetime':
      return (
        <CardInputBlockDate
          key={block.name}
          block={block as DateInputBlock}
          workflowTemplateId={workflowTemplateId}
        />
      );
    case 'geolocation':
      return <MBCardInputBlockGeolocation key={block.name} block={block} />;
    case 'address':
      return <MBCardInputBlockAddress key={block.name} block={block} />;
    case 'file':
      return <FileInputBlock key={block.name} block={block as FileInputBlockType} />;
    case 'image':
      return <MBCardInputBlockImage key={block.name} block={block} />;
    case 'text':
      return <MBCardInputBlockText key={block.name} block={block} />;
    case 'questionCheckbox':
    case 'questionTextArea':
    case 'questionSingleSelect':
      return <MBCardInputBlockQuestion key={block.name} block={block} />;
    case 'float':
    case 'percent':
    case 'currency':
      return <MBCardInputBlockNumber key={block.name} block={block as NumberInputBlock} />;
    case 'textarea':
      return <MBCardInputBlockTextarea key={block.name} block={block} />;
    case 'todo':
      return (
        <MBCardInputBlockTodo
          key={block.name}
          block={block as TodoInputBlock}
          onPress={onFieldPress}
        />
      );
    case 'assignee':
      return <MBCardInputBlockAssignee key={block.name} block={block as AssigneeInputBlock} />;
    case 'toggle':
      return <MBCardInputBlockToggle key={block.name} block={block} />;
    case 'recurrence':
      return <MBCardInputBlockRecurrence key={block.name} block={block as RecurrenceInputBlock} />;
    case 'reminder':
      return <MBCardInputBlockReminder key={block.name} block={block as ReminderInputBlock} />;
    case 'tags':
      return <MBCardInputBlockTags key={block.name} block={block as TagsInputBlock} />;
    case 'cards':
      return <MBCardInputBlockCards key={block.name} block={block as CardsInputBlock} />;
    case 'signature':
      return <SignatureInputBlock key={block.name} block={block} />;
    case 'subforms':
      return (
        <SubformsInputBlock
          key={block.name}
          block={block as SubformsInputBlockType}
          value={value}
          workflowTemplateId={workflowTemplateId}
        />
      );
    default:
      return null;
  }
}
